export enum PriceType {
  SinglePrice = 1,
  PriceRange = 2,
}
